import React from 'react';
import { ShoppingCart } from 'lucide-react';
import { useCart } from '../../../contexts/CartContext';

const CartPanel: React.FC = () => {
  const { itemCount, totalItems, openPurchaseModal, isPurchaseModalOpen } = useCart();

  if (itemCount === 0 || isPurchaseModalOpen) {
    return null;
  }

  const handleClick = () => {
    if (!isPurchaseModalOpen) {
      openPurchaseModal();
    }
  };

  return (
    <div className="fixed bottom-8 right-8 z-50">
      <button
        onClick={handleClick}
        className="relative bg-gradient-to-br from-yellow-400 to-amber-500 hover:from-yellow-500 hover:to-amber-600 text-white p-4 rounded-full shadow-2xl hover:shadow-yellow-500/50 transition-all hover:scale-110 group"
      >
        <ShoppingCart className="w-6 h-6" />
        <div className="absolute -top-2 -right-2 bg-red-500 text-white text-xs font-bold rounded-full w-6 h-6 flex items-center justify-center border-2 border-white">
          {totalItems}
        </div>
      </button>
    </div>
  );
};

export default CartPanel;
